import { render, staticRenderFns } from "./AddLoanBankModal.vue?vue&type=template&id=75b3a628&scoped=true&"
import script from "./AddLoanBankModal.vue?vue&type=script&lang=js&"
export * from "./AddLoanBankModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLoanBankModal.vue?vue&type=style&index=0&id=75b3a628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b3a628",
  null
  
)

export default component.exports